module.exports = __webpack_public_path__ + "static/img/hire1.452b257.png";


//////////////////
// WEBPACK FOOTER
// ./static/hire/hire1.png
// module id = MPwm
// module chunks = 1